import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { BoosterWagerBonus } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../styled'

const BoostWagerBonusCondition: React.FC<{ bonus: BoosterWagerBonus } & BoxProps> = ({ bonus, ...props }) => {
  return (
    <>
      <BonusContentGridSystem {...props}>
        <BonusContentFieldTitle>
          <Trans>Max Boostable</Trans>
        </BonusContentFieldTitle>
        <Text fontWeight="700" fontSize="12px" lineHeight="normal">
          {`$${bonus.maxBooster}`}
        </Text>
      </BonusContentGridSystem>
      <BonusContentGridSystem mt="8px">
        {!bonus.condition.isExpired && (
          <>
            <BonusContentFieldTitle>
              <Trans>Active time</Trans>
            </BonusContentFieldTitle>
            <Text fontWeight="700" fontSize="12px" lineHeight="normal">
              {`${bonus.boostHourDuration}h`}
            </Text>
          </>
        )}
      </BonusContentGridSystem>
    </>
  )
}

export default BoostWagerBonusCondition
